/**
 * Error message constants
 */

export const ERROR_MESSAGES = {
  MAPBOX_TOKEN_NOT_CONFIGURED:
    'Mapbox access token is not configured. Please add MAPBOX_KEY to config.js',
  MAP_ERROR: 'Map error:',
  MAP_INITIALIZATION_FAILED: 'Failed to initialize map:',
  SVG_ICON_NOT_FOUND: 'SVG icon not found in registry:',
  MAPBOX_TOKEN_NOT_CONFIGURED_GEOCODING: 'Mapbox access token not configured',
  ADDRESS_REQUIRED: 'Address is required',
  ADDRESS_NOT_FOUND: 'Address not found',
  GEOCODING_FAILED: 'Failed to geocode address',
  REVERSE_GEOCODING_FAILED: 'Mapbox reverse geocoding failed:',
  GEOCODING_FAILED_GENERIC: 'Mapbox geocoding failed:',
  VALID_COORDINATES_REQUIRED: 'Valid latitude and longitude are required',
  KML_FETCH_FAILED: 'Failed to fetch KML:',
  KML_PARSE_FAILED: 'Failed to parse KML file',
  KML_BOUNDS_NOT_FOUND: 'No bounds found in KML file',
  OVERLAY_IMAGE_LOAD_FAILED: 'Failed to load overlay image',
  HEATMAP_LOAD_FAILED: 'Failed to load heatmap',
  HEATMAP_DATA_NOT_FOUND: 'No heatmap data found for height:',
  HEATMAP_URLS_NOT_FOUND: 'No heatmap URLs found for type:',
  HEATMAP_TYPE_MISSING: 'Missing heatmap data for type:',
  INVALID_HEIGHT_FORMAT: 'Invalid height format:',
  EXPECTED_HEIGHT_FORMAT: 'Expected format: "above_roof_above_open"',
  API_KEY_REQUIRED: 'API key is required for health check',
  INVALID_API_KEY: 'Invalid API Key',
  MISSING_REQUIRED_PARAMETERS: 'Missing required parameters for findBNs',
  REMOTE_NODE_DATA_REQUIRED: 'Remote node data and operator key are required',
  URL_PART_AND_API_KEY_REQUIRED: 'URL part and API key are required',
  URL_REQUIRED: 'URL is required for getting SVG data',
  FAILED_TO_FIND_BASE_NODES: 'Failed to find base nodes',
  FAILED_TO_FIND_OPERATORS: 'Failed to find operators',
  FAILED_TO_LOAD_COUNTRY_LIST: 'Failed to load country list',
  FAILED_TO_CALCULATE_LOST_SECTORS: 'Failed to calculate lost sectors',
  FAILED_TO_CHECK_API_KEY: 'Failed to check API key',
  LEGEND_IMAGE_LOAD_FAILED: 'Failed to load legend image:',
} as const;
